import React, { useState, useRef, useEffect } from 'react';
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { SendHorizontal } from "lucide-react";

const ChatInput = ({ onSendMessage, isLoading, initialMessage }) => {
  const [message, setMessage] = useState('');
  const textareaRef = useRef(null);

  // Set initial message when provided
  useEffect(() => {
    if (initialMessage) {
      setMessage(initialMessage);
      // Focus the textarea when initial message is set
      if (textareaRef.current) {
        textareaRef.current.focus();
        // Position cursor at the end
        setTimeout(() => {
          if (textareaRef.current) {
            textareaRef.current.setSelectionRange(initialMessage.length, initialMessage.length);
          }
        }, 0);
      }
    }
  }, [initialMessage]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (message.trim() && !isLoading) {
      const msg = message;
      setMessage('');
      try {
        await onSendMessage(msg);
      } catch (error) {
        console.error('Failed to send message:', error);
      }
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex items-end gap-2 p-4">
      <Textarea
        ref={textareaRef}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="Kirjoita viesti..."
        className="min-h-[60px] resize-none"
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSubmit(e);
          }
        }}
      />
      <Button type="submit" size="icon" disabled={!message.trim() || isLoading}>
        <SendHorizontal className="h-4 w-4" />
      </Button>
    </form>
  );
};

export default ChatInput; 